import React, { useEffect, useState } from 'react';

function generateUUID() {
    // Public Domain/MIT
    let d = new Date().getTime(); // Timestamp
    let d2 = (performance && performance.now && performance.now() * 1000) || 0; // Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16; // random number between 0 and 16
        if (d > 0) {
            // Use timestamp until depleted
            // eslint-disable-next-line no-bitwise
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            // Use microseconds since page-load if supported
            // eslint-disable-next-line no-bitwise
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        // eslint-disable-next-line no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

export const sendDialogCustuom = (title, message, type, duration, naviga, route, buttonCaption) => {
    dispatchEvent(new CustomEvent('dialog', { detail: { title, message, type, duration, naviga, route, buttonCaption } }));
};

const useDialogCustuom = () => {
    const [dialog, setDialog] = useState([]);

    const _closeNotification = (_notify, id) => {
        const idx = _notify.findIndex((item) => item.id === id);
        if (idx >= 0) {
            _notify.splice(idx, 1);
        }
        return _notify;
    };

    const handleNotify = (e) => {
        let { title, type, duration, message, naviga, route, buttonCaption} = e.detail;

        if(typeof message === "object" && !React.isValidElement(message)) {
            message = JSON.stringify(message);
        }
        if(typeof title === "object" && !React.isValidElement(title)) {
            title = JSON.stringify(title);
        }
        const _notify = [...dialog];

        if (_notify.length >= 10) {
            _notify.splice(0, 1);
        }
        const id = generateUUID();
        setDialog([
            ..._notify,
            {
                title,
                message,
                type,
                naviga,
                route,
                buttonCaption,
                id,
            },
        ]);
        setTimeout(
            () => setDialog((_notifies) => _closeNotification([..._notifies], id)),
            duration * 1000
        );
    };

    const closeNotification = (id) => {
        setDialog((_notify) => _closeNotification([..._notify], id));
    };

    useEffect(() => {
        window.addEventListener('dialog', handleNotify);
        return () => window.removeEventListener('dialog', handleNotify);
    }, [dialog]);

    return [dialog, closeNotification];
};

export default useDialogCustuom;
